
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ReportPurTaxLongGrid extends Serenity.EntityGrid<ReportPurTaxLongRow, any> {
        protected getColumnsKey() { return ReportPurTaxLongColumns.columnsKey; }
        protected getDialogType() { return ReportPurTaxLongDialog; }
        protected getIdProperty() { return ReportPurTaxLongRow.idProperty; }
        protected getInsertPermission() { return ReportPurTaxLongRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportPurTaxLongRow.localTextPrefix; }
        protected getService() { return ReportPurTaxLongService.baseUrl; }

        public mn: string;
        public year: string;
        public shop:string;

        constructor(container: JQuery) {
            super(container);
            let qryrow = Q.tryFirst(QRreport.QRywcSpecRow.getLookup().items,x => x.Id == 117)

            this.mn = qryrow.DocMonth ?? "";
            this.year = qryrow.DocYear ?? "";
            this.shop = qryrow.ShopId ?? "";
            console.log(qryrow.DocMonth ?? "")

            // if (!Q.isEmptyOrNull(shop)) {
            //     this.shop = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x => x.ShopId == shop).BranchName
            // }else{
            //     this.shop = 'ทุกสาขา';
            // }
        
        }

        

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: ReportPurTaxLongService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            
        
            buttons.push(
                {
                    title: Q.text("PDf"), // *** Get button text from translation
                    cssClass: '.panel-pdf',
                    icon: 'fa fa-file-pdf-o text-red',
                    onClick: () => {
                        //var row = this.view.getRows();                        
                    const request = this.getView().params as ReportPurTaxLongData
                    if (!Q.isEmptyOrNull(this.mn)) {
                        request.Month = Q.tryFirst(QRreport.QMonthRow.getLookup().items, x => x.Months == this.mn).MonthName
                    }

                    request.Year = (Number(this.year)+543).toString();
                    let Para = Q.tryFirst(Administration.CsParaRow.getLookup().items, x => x.Id == 1)
                    request.BizName = Para.TaxInvName;
                    
                    if (!Q.isEmptyOrNull(this.shop)) {
                        let Shop = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x => x.ShopId == this.shop)
                        request.ShopName = Shop.ShopRegName;
                        request.ShopTaxId = Shop.ShopTaxId;
                        request.ShopAddress = Shop.ShopRegAddressLine1 + " " + Shop.ShopRegAddressLine2 + " " + Shop.ShopRegAddressLine3;
                        request.BranchName = Shop.BranchName;

                    }else{
                        request.ShopName = Para.TaxInvName;
                        request.ShopTaxId = Para.TaxId;
                        request.ShopAddress = Para.TaxInvAddrLine1 + " " + Para.TaxInvAddrLine2 + " " + Para.TaxInvAddrLine3;
                        request.BranchName = "ทุกสาขา";
                      
                    }
                     request.Details = this.view.getRows();
              
                    Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                        // GeniuzPOS.Purchase.PoCNRTVService.GetNextNumber
                        
                    },
               
                }
            ); 

           
            // import { ReportHelper } from "@serenity-is/extensions";
            
            // buttons.push(Serenity.Exception.ReportHelper.createToolButton({
                // buttons.push(Serenity.Extensions.ReportHelper.createToolButton({
                //     buttons.push(GeniuzPOS.Common.ReportHelper.createToolButton({

                //     title: 'test',
                //     cssClass: 'export-pdf-button',
                //     reportKey: 'Purchase.ReportPurTaxLong',
                //     getParams: () => ({
                //         Shop: this.shop,
                //         Year:(Number(this.year)+543).toString(),
                //         Month: Q.tryFirst(QRreport.QMonthRow.getLookup().items, x => x.Months == this.mn).MonthName,
                //         Details:this.view.getRows()
                //        // OrderID: this.entityId
                //     })

                // }));



                // import { ExcelExportHelper, PdfExportHelper, ReportHelper } from "@serenity-is/extensions";
                // buttons.push(Serenity.Extensions.PdfExportHelper.createToolButton({
                //     grid: this,
                //     onViewSubmit: () => this.onViewSubmit()
                // }));///ใช้ไม่ได้ภาษาไทยต่างด้าว
        
            
        
           
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpecPurTax/edit/117';
                        return false;
                    },
                }
            );       


            return buttons;
        }

        // export function createToolButton(options: ReportButtonOptions): Serenity.ToolButton {
        //     return {
        //         title: Q.coalesce(options.title, 'Report'),
        //         cssClass: Q.coalesce(options.cssClass, 'print-button'),
        //         icon: options.icon,
        //         onClick: () => {
        //             ReportHelper.execute(options);
        //         }
        //     };
        // }
    
        // export function execute(options: ReportExecuteOptions) {
        //     var opt = options.getParams ? options.getParams() : options.params;
    
        //     Q.postToUrl({
        //         url: '~/Report/' + (options.download ? 'Download' : 'Render'), // ???
        //         params: {
        //             key: options.reportKey,
        //             ext: Q.coalesce(options.extension, 'pdf'),
        //             opt: opt ? $.toJSON(opt) : ''
        //         },
        //         target: Q.coalesce(options.target, '_blank')
        //     });
        // }
    

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();          

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            
            this.view.setSummaryOptions({
                aggregators: [
                    
                    
                    new Slick.Aggregators.Sum('NetAmt'),
                    new Slick.Aggregators.Sum('VatAmt'),
                    new Slick.Aggregators.Sum('TotalAmt')
                   
                ]

                

            });     
            return grid;
        }

        protected createQuickSearchInput() {
        }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected usePager() {
            return false;
        }

        // protected onClick(e: Event, row: number, cell: number) {
        //     super.onClick(e, row, cell);
    
        //     if (Fluent.isDefaultPrevented(e))
        //         return;
    
        //     var item = this.itemAt(row);
        //     let action = (e.target as HTMLElement)?.closest(".inline-action")?.getAttribute("data-action");
        //     if (action) {
        //         e.preventDefault();
        //         if (action == "print-invoice") {
        //             ReportHelper.execute({
        //                 reportKey: 'Northwind.OrderDetail',
        //                 params: {
        //                     OrderID: item.OrderID
        //                 }
        //             });
        //         }
        //     }
        // }

        
    }
}